import React from 'react';
import { useParams } from 'react-router-dom';

function Dashboard() {
  const { id } = useParams();
  const creator = {
    id,
    name: id.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
    gifts: ["Crypto Tribute", "Wishlist Item"],
    tiers: ["Bronze", "Gold"],
  };

  return (
    <div className="dashboard-container">
      <h2>{creator.name}'s Dashboard</h2>

      <section>
        <h3>Gift Listings</h3>
        <ul>
          {creator.gifts.map((gift, index) => (
            <li key={index}>{gift}</li>
          ))}
        </ul>
      </section>

      <section>
        <h3>Subscription Tiers</h3>
        <ul>
          {creator.tiers.map((tier, index) => (
            <li key={index}>{tier}</li>
          ))}
        </ul>
      </section>

      <section>
        <h3>Quick Actions</h3>
        <button onClick={() => alert("Add Gift feature coming soon")}>Add Gift</button>
        <button onClick={() => alert("Add Tier feature coming soon")}>Add Tier</button>
      </section>
    </div>
  );
}

export default Dashboard;


